<script>
  import Button from '@components/buttons/button.svelte'
  import Image from '@components/general/image.svelte'
  import UpdateForm from '@components/contributors/form.svelte'

  let { contributor, admin = false, fallback = "-", imageProps = {}, ...buttonProps } = $props()

  let formOpen = $state(false)

  let path = $derived(admin ? null : `/contributors/${contributor.id}`)

  let onclick = $derived(admin ? () => formOpen = true : null)
  
</script>

{#if contributor}
  <Button variant="link" {path} {onclick} {...buttonProps}>
    <Image src={contributor.image} alt={contributor.name} loading="lazy" class="size-4 border border-gray-200/70 bg-gray-100 rounded-full" {...imageProps} />
    <span>{contributor.name}</span>
  </Button>
{:else}
  <span>{fallback}</span>
{/if}

<UpdateForm bind:open={formOpen} contributor={contributor} onClose={() => formOpen = false} />